import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledAccessTabContainer = styled.section`
  width: 100%;
`;

export const StyledAccessContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  margin-top: 2.4rem;
`;

export const StyledAccessDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

// max-width: 430px cover mobiles starting at 430
export const StyledAccessLink = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
  word-wrap: break-word;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 40rem;
  }

  @media screen and (max-width: 1024px) {
    width: 15rem;
  }

  @media screen and (max-width: 430px) {
    width: 10rem;
  }
`;

export const StyledMembersWrapper = styled.section`
  margin-top: 2.4rem;
`;

export const StyledMembersContentWrapper = styled.div`
  margin-top: 2.4rem;
`;

export const StyledMembersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.6rem;
`;

export const StyledMemberDisplayWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const StyledMemberName = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledOverlappedMembersContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledOverlappedMemberWrapper = styled.div`
  position: relative;
  margin-right: -0.8rem;
  overflow: hidden;
`;

export const StyledOverlappedMembers = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
`;

export const StyledRemainingMembers = styled.div`
  height: 3.2rem;
  width: 3.2rem;
  border-radius: 100%;
  position: relative;
  margin-right: -0.8rem;
  background-color: ${({ theme }) => theme.colors.grey[900]};
  color: ${({ theme }) => theme.colors.grey[100]};
  border: 0.3rem solid ${({ theme }) => theme.colors.grey[900]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    height: 5.2rem;
    width: 5.2rem;
  }
`;

export const StyledShowMembersButton = styled.button`
  color: ${({ theme }) => theme.colors.info.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-decoration: underline;
`;

export const StyledAllMembersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5.6rem;
  row-gap: 1.6rem;
  margin-bottom: 2.4rem;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
